import { styled } from "@mui/system";
import { Typography, Box } from "@mui/material";
import leadpixieLogo from "../../../assets/leadpixie_logo.png"

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(2),
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
  },
}));

const StyledCaption = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  variant: "caption",
  component: "span",
  color: "#424343",
  // font: "normal normal 400 16px open sans",

  [[theme.breakpoints.between("xs", "sm")]]: {
    font: "normal normal 400 8px open sans",
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    font: "normal normal 400 10px open sans",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 400 12px open sans",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 400 16px open sans",
  },
}));

const FooterComponent = ({ contentState }) => {
  return (
    <Container>
      <StyledCaption>
        {contentState.footer_text}
        {contentState.pp_link !== "" ? (
          <a href={contentState.pp_link} target="_blank">
            Privacy Policy
          </a>
        ) : (
          "Privacy Policy"
        )}
      </StyledCaption>
      <Box
        component="a"
        href="https://leadpixie.ai"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          //on large - show as fab; small - show at bottom
          position: { xs: "static", md: "fixed" },
          bottom: { md: 16 },
          left: { md: 16 },
          zIndex: 1300,
          mt: 1,

          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          py: 0.75,
          borderRadius: 999,
          bgcolor: 'rgba(255, 255, 255, 0.9)',
          border: { xs: "1.5px solid rgba(33, 88, 159, 0.4)", md: '1.5px solid transparent' },

          whiteSpace: 'nowrap',
          transition: 'border-color 0.25s ease',
          textDecoration: 'none',

          '&:hover': {
            bgcolor: 'rgba(255, 255, 255)',
            borderColor: '#21589F', // leadpixie blue
          },
        }}
      >
        <Typography
          sx={{
            fontSize: '0.75rem',
            fontWeight: 500,
            color: '#111',
          }}
        >
          Powered by
        </Typography>

        <Box
          component="img"
          src={leadpixieLogo}
          alt="Leadpixie"
          sx={{
            height: 10,
            display: 'block',
          }}
        />
      </Box>
    </Container>
  );
};

export default FooterComponent;
